/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_For_Candidates_TitleInputs */

const en_stats_for_candidates_title = /** @type {(inputs: Stats_For_Candidates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For candidates`)
};

const de_stats_for_candidates_title = /** @type {(inputs: Stats_For_Candidates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Kandidat*innen`)
};

/**
* | output |
* | --- |
* | "For candidates" |
*
* @param {Stats_For_Candidates_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const stats_for_candidates_title = /** @type {((inputs?: Stats_For_Candidates_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_For_Candidates_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_stats_for_candidates_title(inputs)
	return en_stats_for_candidates_title(inputs)
});